import 'dayjs/locale/fr';

import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import durationPlugin from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';
import localizedFormatPlugin from 'dayjs/plugin/localizedFormat';
import minMaxPlugin from 'dayjs/plugin/minMax';
import relativeTimePlugin from 'dayjs/plugin/relativeTime';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';

// Dayjs offers opt-in plugins to enhance its API.
// https://day.js.org/docs/en/plugin/plugin

dayjs.extend(localizedFormatPlugin);
dayjs.extend(durationPlugin);
dayjs.extend(relativeTimePlugin);
dayjs.extend(customParseFormat);
dayjs.extend(minMaxPlugin);
dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(weekOfYear);
dayjs.extend(weekday);
dayjs.extend(advancedFormat);
dayjs.extend(isBetween);

// Currently we can't set the 'fr' locale from the mobile project.
// It is therefore set here by default to correct this mobile problem.
// This has no impact on web locale management if the user's browser is in English, for example.
dayjs.locale('fr');

export default dayjs;
